'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _DataSelector = require('../../common/Class/DataSelector');

var _DataSelector2 = _interopRequireDefault(_DataSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  atc: new _DataSelector2.default('data-main-add-to-cart'),
  stickyAtc: new _DataSelector2.default('data-desktop-sticky-atc-bar'),
  header: new _DataSelector2.default('data-header-main')
};

var dom = {};

var ACTIVE_CLASS = 'active';

/**
 * passive event listener
 */
var onScroll = function onScroll() {
  if (!dom.atc || !dom.stickyAtc) {
    return;
  }

  var atcPosition = dom.atc.getBoundingClientRect().top + dom.atc.offsetHeight; // bottom of add to cart
  var headerHeight = dom.header.offsetHeight;

  if (atcPosition < headerHeight) {
    // normal at in view
    dom.stickyAtc.classList.add(ACTIVE_CLASS);
    dom.stickyAtc.style.top = headerHeight + 'px';
  } else {
    dom.stickyAtc.classList.remove(ACTIVE_CLASS);
    dom.stickyAtc.style.top = null;
  }
};

var cacheDom = function cacheDom() {
  dom.atc = selectors.atc.node();
  dom.stickyAtc = selectors.stickyAtc.node();
  dom.header = selectors.header.node();
};

var init = exports.init = function init() {
  cacheDom();
  window.addEventListener('scroll', onScroll);
  onScroll(); // initial
};